import { render, staticRenderFns } from "./dataDashBoard.vue?vue&type=template&id=2755cef2&scoped=true"
import script from "./dataDashBoard.vue?vue&type=script&lang=js"
export * from "./dataDashBoard.vue?vue&type=script&lang=js"
import style0 from "./dataDashBoard.vue?vue&type=style&index=0&id=2755cef2&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755cef2",
  null
  
)

export default component.exports